export default __webpack_public_path__ + "static/media/KingStake.e4c618c7.png";